/*
  Dabi Deri — havada süzülen sosyal medya ikonu.

  - Başlığın alt kenarını ölçüp `--dabi-header-bottom` olarak yazıyor;
    "başlığın üzerinde" konumları buna göre duruyor. Başlık yüksekliği
    sayfaya ve ekrana göre değiştiği için sabit bir değer kullanılamazdı.
  - Dokunmatikte "üzerine gelme" yok: ikona dokununca yay açılıyor,
    dışarı dokununca kapanıyor. Farede üzerine gelmek yetiyor.
*/

(() => {
  const host = document.querySelector('[data-dabi-socialfloat]');
  const root = document.documentElement;

  let frame = null;
  const measure = () => {
    frame = null;
    if (document.querySelector('.dabi-header[data-scroll-mode]')) return;
    const header = document.querySelector('.dabi-header-wrap .dabi-header') || document.querySelector('.dabi-header-wrap') || document.querySelector('.shopify-section-group-header-group');
    if (!header) return;
    root.style.setProperty('--dabi-header-bottom', `${Math.max(0, Math.round(header.getBoundingClientRect().bottom))}px`);
  };
  const queue = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(measure);
  };

  measure();
  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('load', measure);
  // Baslik boyu degistikce (logo yuklenince vb.) yeniden olc.
  const headerEl = document.querySelector('.dabi-header-wrap .dabi-header') || document.querySelector('.dabi-header-wrap');
  if (headerEl && 'ResizeObserver' in window) new ResizeObserver(measure).observe(headerEl);

  if (!host) return;

  const fan = host.querySelector('.dabi-socialfan');
  const trigger = host.querySelector('[data-dabi-fan-trigger]');
  if (!fan || !trigger) return;

  const setOpen = (open) => {
    fan.classList.toggle('is-open', open);
    host.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    setOpen(!fan.classList.contains('is-open'));
  });

  document.addEventListener('pointerdown', (event) => {
    if (!host.contains(event.target)) setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && fan.classList.contains('is-open')) {
      setOpen(false);
      trigger.focus();
    }
  });

  // Farede imleç çıkınca tıklamayla açılmış yay da kapansın.
  host.addEventListener('pointerleave', (event) => {
    if (event.pointerType === 'mouse') setOpen(false);
  });
})();
